import React, { useEffect, useState } from 'react';
import './App.css';
import './static/animations.scss'
import './static/fonts.scss'
import { RouterProvider } from 'react-router-dom';
import router from './components/Routing/routing';
import { AuthProvider } from './components/Authorization/AuthContext';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { detectSetLanguage } from './i18n'

const App = () => {
  const [isLoadingLanguage, setIsLoadingLanguage] = useState(true)

  useEffect(() => {
		detectSetLanguage(setIsLoadingLanguage)
	}, [])

  if (isLoadingLanguage) {
    return <div></div> 
  }

  return (
    <Provider store={store}>
      <AuthProvider>
        <RouterProvider router={router}/>
      </AuthProvider>
    </Provider>
  )
}

export default App;
